/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crazy_Sweet_Crow_TypeInputs */

const fr_crazy_sweet_crow_type = /** @type {(inputs: Crazy_Sweet_Crow_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

/**

* @param {Crazy_Sweet_Crow_TypeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const crazy_sweet_crow_type = /** @type {((inputs?: Crazy_Sweet_Crow_TypeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crazy_Sweet_Crow_TypeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_crazy_sweet_crow_type(inputs)
});